import { apiUrl } from "../config/environment";

// Same entry route and return-to-page contract as Sniper's loginByGoogle.
export function loginByGoogle(pathname?: string) {
  const state = pathname ? "?state=" + encodeURIComponent(JSON.stringify({ pathname })) : "";
  window.location.assign(apiUrl("/auth/google") + state);
}
